import React from "react";

const Footer = () => {
  return (
    <footer
    dir="ltr"
    className="w-full text-center font-[BdReg] py-10 relative bg-black">
      
      {/* TOP LINE */}
      <span className="block w-full h-px bg-[#63bfc2]/60 mb-5" />

      {/* TEXT */}
      <p className="text-sm text-white tracking-wide">
        © 2026 © MHERO All Rights Reserved.
      </p>

    </footer>
  );
};

export default Footer;
